import { Plugin, PluginKey } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';

export const VARIABLE_HIGHLIGHT_KEY = new PluginKey('variableHighlight');

export function createVariableHighlightPlugin(getLabelFn) {
  return new Plugin({
    key: VARIABLE_HIGHLIGHT_KEY,
    props: {
      decorations(state) {
        const decorations = [];
        const regex = /\{\{([\w.]+)\}\}/g;
        state.doc.descendants((node, pos) => {
          if (!node.isText) return;
          regex.lastIndex = 0;
          let match;
          while ((match = regex.exec(node.text)) !== null) {
            const start = pos + match.index;
            const end = start + match[0].length;
            const label = getLabelFn(match[1]) || match[0];
            decorations.push(
              Decoration.inline(start, end, {
                class: 'prosemirror-variable-node',
                'data-label': label,
              })
            );
          }
        });
        return DecorationSet.create(state.doc, decorations);
      },
    },
  });
}
